import React from "react";
import "./CreateUserMain.css";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../assests/leftArrow.svg";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import CohortContainer from "../AddCohort/container";
import CreateusersDetails from "../CreateUserComp/container.js";
import AddWarehouseContainer from "../AddWarehouseComp/container.js";
import avtar2 from "../../assests/emotions2.svg";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

const CreateUser = (props) => {
  const steps = ["Basic Details", "Add to Cohort", "Add to Warehouse"];
  const navigate = useNavigate();

  const arrowClick = () => {
    navigate("/home/users/list");
  };

  const handleBack = () => {
    props.setShow(true);
  };

  const handleCancel = () => {
    props.setShow(false);
  };

  return (
    <div className="create-user-container">
      <div className="create-user-sidebar">
        <Sidebar />
      </div>
      
      <div className="create-user-content">
        <div className="create-user-header">
          <img
            onClick={arrowClick}
            className="create-user-back-arrow"
            src={leftArrow}
            alt="Back"
          />
          <h2 className="create-user-title">Create New User</h2>
        </div>
        
        <div className="create-user-stepper-container">
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={props.activeStep} className="create-user-stepper">
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
        
        <div className="create-user-step-content">
          {props.activeStep === 0 && <CreateusersDetails />}
          {props.activeStep === 1 && <CohortContainer />}
          {props.activeStep === 2 && <AddWarehouseContainer />}
        </div>
        
        {/* Material-UI Modal */}
        <Modal
          open={props.show}
          onClose={handleCancel}
          aria-labelledby="confirmation-modal"
          aria-describedby="confirmation-dialog"
          className="create-user-modal"
        >
          <Paper className="create-user-modal-content">
            <div className="create-user-modal-image">
              <img src={avtar2} alt="Warning" />
            </div>
            <div className="create-user-modal-text">
              <Typography variant="h6" component="p">
                Want to go back?
              </Typography>
              <Typography variant="body2" component="span">
                All unsaved changes will be lost.
              </Typography>
            </div>
            <div className="create-user-modal-buttons">
              <Button 
                variant="outlined" 
                className="create-user-modal-cancel" 
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button 
                variant="contained" 
                className="create-user-modal-confirm" 
                onClick={props.handleClose}
              >
                Yes, go back
              </Button>
            </div>
          </Paper>
        </Modal>

        <Box className="create-user-navigation-buttons">
          <Button
            className="create-user-back-button"
            disabled={props.activeStep === 0}
            onClick={handleBack}
          >
            Back
          </Button>

          {props.activeStep === steps.length - 1 ? (
            <Button
              className="create-user-save-button"
              onClick={props.Createuserapi}
            >
              Save
            </Button>
          ) : (
            <Button
              className="create-user-continue-button"
              onClick={props.handleNext}
            >
              Save and Continue
            </Button>
          )}
        </Box>
      </div>
    </div>
  );
};

export default CreateUser;